import { on } from 'delegated-events'

const titlesJson = document.getElementById('video-category-meta-titles')

if (titlesJson) {
  const titles = JSON.parse(titlesJson.textContent)

  on('pagefilters:update', 'html', (e) => {
    if (e.detail.data) {
      const category = e.detail.data.get('category')

      if (category) {
        const urlSegment = category.split('/').reverse()[0]

        if (urlSegment in titles) {
          const metaTitle = titles[urlSegment]

          document.querySelector('title').textContent = metaTitle
        }
      }
    }

    if (e.detail.type && e.detail.type === 'clear') {
      document.querySelector('title').textContent = titles['_default']
    }
  })
}
